import { FormControl, Grid, TextField } from '@mui/material'
import React from 'react'

export const CreditInformation = ({useFetchInit}) => {

  const {
    FetchData,
    Actions,
    globalStates,
    Forms
  }= useFetchInit

  const {handleClickSearchPayments, handleKeyDown, handleClickFechtVehicleCredits, handleChangeCredit} = Actions

  const {FormRequestGlobal:{formState, onInputChange, onSelectSearchChange}} = Forms

  // const {fetchAllVehicleCredits:{vehicleCredits}} = FetchData

  return (
    <>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
    
        <Grid item xs={12} sm={12} md={4} lg={4} sx={{mt:2, mb:1}}>
          <FormControl fullWidth>
            <label htmlFor="suma_total_pagar">SALDO DE CREDITO (Q)</label>
            <TextField
                id='suma_total_pagar'
                name='suma_total_pagar'
                value={ formState.suma_total_pagar }
                onChange={ onInputChange }
                size='small'
                placeholder='SALDO DE CREDITO (Q)'
                type='text'
                variant={'filled'}
                InputProps={{
                  readOnly: true
                }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={4} lg={4} sx={{mt:2, mb:1}}>
          <FormControl fullWidth>
            <label htmlFor="total_gastos_juridicos">GASTOS JURIDICOS (Q)</label>
            <TextField
                id='total_gastos_juridicos'
                name='total_gastos_juridicos'
                value={ formState.total_gastos_juridicos }
                onChange={ onInputChange }
                size='small'
                placeholder='GASTOS JURIDICOS (Q)'
                type='text'
                variant={'filled'}
                InputProps={{
                  readOnly: true
                }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={4} lg={4} sx={{mt:2, mb:1}}>
          <FormControl fullWidth>
            <label htmlFor="total_gastos_admin">GASTOS ADMINISTRATIVOS (Q)</label>
            <TextField
                id='total_gastos_admin'
                name='total_gastos_admin'
                value={ formState.total_gastos_admin }
                onChange={ onInputChange }
                size='small'
                placeholder='GASTOS ADMINISTRATIVOS (Q)'
                type='text'
                variant={'filled'}
                InputProps={{
                  readOnly: true
                }}
            />
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}
